import React from 'react'
import Divider from '@components/V3/Divider'
import useScreenSize from '@hooks/useScreenSize'
import dynamic from 'next/dynamic'

import CouponSkeleton from '../Coupon/Skeleton'

import AddressSkeleton from './Address/Skeleton'
import CartSkeleton from './Cart/Skeleton'
import LoginSkeleton from './LogIn/Skeleton'
import ScheduleSkeleton from './Schedule/Skeleton'

const Address = dynamic(() => import('./Address'), {loading: () => <AddressSkeleton />})
const Cart = dynamic(() => import('./Cart'), {loading: () => <CartSkeleton />})
const LogIn = dynamic(() => import('./LogIn'), {loading: () => <LoginSkeleton />})
const Schedule = dynamic(() => import('./Schedule'), {loading: () => <ScheduleSkeleton />})
const Coupon = dynamic(() => import('../Coupon'), {loading: () => <CouponSkeleton />})
const CustomFields = dynamic(() => import('./CustomFields'))
const Gift = dynamic(() => import('./Gift'))

export default function Main() {
  const screenSize = useScreenSize()
  return (
    <>
      <LogIn />
      {['mobile', 'sm'].includes(screenSize) ? <Divider /> : null}
      <Schedule />
      <Address />
      <Cart />
      <Gift />
      <CustomFields />
      {['mobile', 'sm'].includes(screenSize) ? <Coupon /> : null}
    </>
  )
}
